import { useEffect } from "react";

const SuccessPopup = ({ onClose }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
    <div className="popup-positive bg-[#fff] pt-[60px] pb-[30px] px-[45px] lg:py-[29px] lg:px-[53px] text-center w-full max-w-[335px] sm:max-w-[571px] rounded-[16px]">
      <div className="relative">
        <div className="text-[22px] md:text-[26px] font-bold">
          Thank you for getting in touch!
        </div>

        <button
          onClick={onClose}
          className="absolute top-[-29px] right-[-29px] md:right-[-19px] md:top-0 p-1"
          aria-label="Close"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
          >
            <g opacity="0.4">
              <path
                d="M8.44661 21.5538L15.0004 15.0001L21.5541 21.5538M21.5541 8.44631L14.9991 15.0001L8.44661 8.44631"
                stroke="#110D38"
                strokeWidth="1.875"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        </button>
      </div>
      <div className="text-[15px] md:text-[20px] opacity-[0.6] mt-[10px] md:mt-[13px] mb-[20px] leading-[18px] md:leading-[22px]">
        Your message has been successfully sent. We’ll get back to you as soon
        as possible.
      </div>

      <button
        className="bg-[#1A6867] rounded-[10px] text-[#fff] text-[18px] md:text-[22px] leading-[22px] py-[14px] md:py-[20.5px] w-[100%] max-w-[343px] border-none outline-none cursor-pointer font-inherit appearance-none"
        onClick={onClose}
      >
        Continue
      </button>
    </div>
    </div>
  );
};

export default SuccessPopup;
